import { createContext, FC, useContext } from 'react';

import Paper, { PaperProps } from '@mui/material/Paper';

import css from './PaperWithFooter.module.css';

import { Nullable } from 'v2/types';

export const PaperFooterContext = createContext<Nullable<string>>(null);

// Autocomplete renders its Paper itself, so the footer text comes through context.
export const PaperWithFooter: FC<PaperProps> = ({ children, ...props }) => {
  const footer = useContext(PaperFooterContext);

  return (
    <Paper {...props}>
      {children}
      {footer && <p className={css.paperFooter}>{footer}</p>}
    </Paper>
  );
};

export function getSearchFooter(result?: { result: unknown[]; total: number }): Nullable<string> {
  return result && result.total > result.result.length
    ? `Показано ${result.result.length} из ${result.total} — уточните запрос`
    : null;
}
